// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  scroll-behavior: smooth;
}

/* Public Video Comment css */

.profile-image {
  width: 50px;
  min-width: 50px;
  height: 50px;
  font-size: 22px;
  line-height: 30px;
  margin-right: 10px;
}

body {
  margin-bottom: 50px;
}

/*.public-vid-comments {*/
/*  margin-top: 45px;*/
/*}*/

.embed {
  margin-top: 1px !important;
}

.custom-container {
  /*padding-left: 8%;*/
  /*padding-right: 4%;*/
}
.customEmbed {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.comment-card-sec .card .vid-info h3 {
  font-size: 20px;
  font-weight: 600;

  /*WC 05132022 */
  /*overflow: hidden;
  text-overflow: ellipsis;
  max-width: 300px;*/
  /*WC 05132022 */
}

.comment-card-sec .card .vid-info p,
.comment-card-sec .card .follow-area p {
  font-size: 15px;
}

a.cmt-show-more {
  font-size: 15px;
  color: #6c2fbb !important;
}

.comment-card-sec .card .vid-info p:nth-of-type(2) {
  margin-top: 15px !important;
  font-size: 15px;
}

.pro-group h6 {
  font-size: 14px;
}

.custom-react-button {
  position: relative;
  text-align: CENTER !important;
  margin-left: 10px !important;
  padding: 4px 10px !important;
  background: #e8e8e8 !important;
}

.follow-share {
  padding: 5px 20px;
  font-size: 14px;
  position: relative;
  /*margin-bottom: 15px;*/
  cursor: pointer;

  border-radius: 8px;
    /*width: 45px;*/
    /*height: 45px;*/
  display: flex;
  align-items: center;
  margin-bottom: 3px;
}

.follow-share img {
  border-radius: 10px;
  min-width: 50px;
  /*position: absolute;*/
  /*left: 20px;*/
  /*top: 0;*/
  object-fit: cover;
  margin-right: 10px;
}

.follow-share h5 {
  font-size: 14px;
  /*padding-left: 60px;*/
  /*margin-top: 12px;*/
  margin-bottom: 0;
}

.follow-share.selected-share:before {
  content: "\\2713";
  display: inline-block;
  color: #fff;
  position: absolute;
  top: 5px;
  align-items: center;
  text-align: center;
  left: 20px;
  background: #6c2fbb;
  width: 50px;
  height: 50px;
  /*border-radius: 50%;*/
  border-radius: 10px;
  font-size: 30px;
  z-index: 9;
  opacity: 0.7;
  line-height: 52px;
}

.follow-share.selected-share h5 {
  color: #6c2fbb;
}

.comment-card-sec .card .like-btn button img {
  height: 24px;
}

.comment-card-sec .card .option-btns button {
  font-size: 15px;
  padding: 4px;
  box-shadow: unset;
}

.comment-card-sec .card .option-btns button img {
  margin-left: 10px;
  width: 14px;
  height: 14px;
}

.comment-card-sec .card .option-btns,
.comment-card-sec .card .like-btn {
  text-align: end;
}

.comment-card-sec .card .like-btn {
  float: right;
}

.comment-card-sec .card .follow-area h5 {
  font-size: 16px;
  color: #6c2fbb;
}

.comment-card-sec .card .follow-btn {
  float: right;
}

.comment-card-sec .card .follow-btn button {
  padding: 4px 32px;
  font-size: 14px;
  background: #6c2fbb;
  color: white;
  border-radius: 5px;
  float: right;
  margin-top: 20px;
}

/* Comment css */

.comment-details-sec .cmts-list,
.comment-details-sec .reply-list {
  list-style-type: none;
}

.comment-details-sec .cmts-list > li > .media h6 {
  font-size: 17px;
  font-weight: 500;
}

.comment-details-sec .cmts-list > li > .media p {
  font-size: 15px;
  margin-bottom: 0px;
}

.comment-details-sec .cmts-list > li > .media .cmt-opt {
  font-size: 15px;
}

.comment-details-sec .cmts-list > li > .media h6 span {
  font-size: 15px;
  font-weight: normal;
  color: #a6a3a3;
}

.comment-details-sec .cmts-list > li .reply-list li .media h6 {
  font-size: 16px;
  font-weight: 600;
}

.comment-details-sec .cmts-list > li .reply-list li .media {
  font-size: 15px;
}

.comment-details-sec .cmts-list > li .reply-list li .media h6 span {
  font-size: 14px;
  font-weight: normal;
  color: #a6a3a3;
}

.comment-details-sec .user-commented h4 {
  font-size: 19px;
}

.comment-details-sec .user-commented > ul {
  list-style-type: none;
  padding-left: 0;
}

.comment-details-sec .user-commented > ul li span .cb {
  width: 5px;
  height: 5px;
  display: inline-block;
  border-radius: 50%;
}

.cmts-list .reply-list .all-reply,
.user-commented ul .show-more,
.cmts-list > li > .media .cmt-reply button {
  color: #6c2fbb;
  font-size: 15px;
  padding-left: 0px;
  box-shadow: none;
}

.comment-details-sec .form-group.write-cmt > label {
  border-radius: 50%;
  padding: 8px;
  margin-bottom: 0px;
  font-size: 10px;
  background: lightslategray;
  color: white;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 2%;
}

.comment-details-sec .form-group.write-cmt > input {
  height: 50px;
  border: 1px solid #f4f1f1;
}

.comment-details-sec .like-cmt-select > span {
  position: absolute;
  font-size: 13px;
  left: 15px;
  top: 2px;
  color: #878787;
}

.comment-details-sec .like-cmt-select > select {
  height: 50px;
  font-size: 15px;
}

.comment-details-sec .like-cmt-select button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 2px;
  width: 50px;
  background-color: #f5f7f6;
}

.comment-details-sec .like-cmt-select button span {
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 6px solid #555;
  display: inline-block;
}

.comment-card-sec .cmt-tab-btns > ul li a.active {
  color: black;
  border-bottom: 3px solid black;
}

.comment-card-sec .cmt-tab-btns > ul li a {
  color: #495057;
  padding: 8px 0px;
}

.comment-card-sec .cmt-tab-btns > ul,
.comment-card-sec .cmt-tab-btns > ul li a {
  border: none;
}

/* Comment css */

/* choise sec bullet color css */

.cmt-bullet-c1 {
  background: #6c2fbb;
}

.cmt-bullet-c2 {
  background: #dfbd5b;
}

.cmt-bullet-c3 {
  background: #65cf9c;
}

.cmt-bullet-c4 {
  background: #d14870;
}

/* choise sec bullet color end */

.row.breakdown h4 {
  font-size: 20px;
}

.breakdown .progress-container .pro-group .progress {
  height: 6px;
}

.breakdown .progress-container .progress .progress-bar {
  background-color: #6c2fbb;
}

.breakdown .card-container .card-row {
  display: flex;
  flex-wrap: wrap;
}
.breakdown .card-container .top-card-title {
  position: absolute;
  top: -10px;
  left: 0px;
  color: #fff !important;
  background: #0000007d;
  border: 4px;
  padding: 5px;
  border-radius: 3px;
}

.breakdown .card-container .card-row > div {
  /* width: calc(25% - 12px); */
  width: auto;
  margin: 0px 12px 12px 0px;
  position: relative;
}

.breakdown .card-container .card-row > div img {
  width: 190px;
  height: 150px;
  object-fit: cover;
}

.breakdown .card-container .card-row > div h6 {
  margin-top: 10px;
  color: #000;
  word-break: break-all;
  font-size: 14px;
}

.vid-cover .cmt-toast .toast-header > button {
  font-size: 20px;
}

.comment-card-sec .vid-cover .cmt-toast {
  position: absolute;
  top: 10px;
  left: 12px;
}

.video-player-image {
  width: 100%;
  height: 70vh;
}

.video-control-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  background-color: rgba(43, 51, 63, .7);
  transition: 0.4s ease-in-out all;
  display: flex;
  visibility: visible;
  opacity: 1;
}

/* Public Video Comment css */

/* Private Video Comment css */

.comment-card-sec .vid-menu {
  background: black;
  border-top: 1px solid #ffffff80;
  min-height: 50px;
}

.comment-card-sec .vid-menu > button {
  width: 100%;
  color: white;
  border-right: 1px solid #ffffff80;
  border-radius: 0;
  transition: all 0.2s linear;
}

.comment-card-sec .vid-menu > button:last-child {
  border-right: none;
}

.comment-card-sec .vid-menu > button:hover {
  background-color: #6c2fbb;
}

/* Private Video Comment css */

.optionschoiceitem {
  padding: 25px;
  font-size: 16px;
  /* border-radius: 5px; */
  color: #fff;
  /* margin-right: 10px; */
  /* margin-bottom: 10px; */
  box-shadow: 1px 1px 4px 1px rgba(0, 0, 0, 0.5);
  cursor: pointer;
  display: table-cell;
  letter-spacing: 0.5px;
}

.optionschoiceitem:hover {
  background: #726bfa;
}

.optionsOFchoice {
  opacity: 0.8;
  background: rgba(0, 0, 0, 0.8);
  z-index: 9;
  position: relative;
  display: table;
  width: 100%;
  text-align: center;
  background: #000;
}

/* React modal CSS */

.gray-border-bottom {
  border-bottom: 1px solid #dee2e6;
}

.react-modal-tabs {
  text-align: center;
}

.react-modal-tabs li a img {
  width: 20px;
  height: 20px;
}

.react-modal-tabs li a p {
  margin-bottom: 0;
  font-size: 12px;
}

.user-list {
  list-style-type: none;
  padding: 0;
  margin-top: 10px;
  margin-bottom: 10px !important;
  max-height: 300px;
  overflow: auto;
}

.user-list li {
  margin-bottom: 15px;
  padding-bottom: 54px;
  border-bottom: 1px solid #ccc;
}

.user-list li img.user-profile-pic {
  float: left;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}

.left-image {
  width: 40px;
  height: 40px;
  float: left;
  /* background-color: red; */
}

.right-section {
  width: calc(100% - 40px);
  height: 40px;
  float: left;
  /* background-color: teal; */
  color: #fff;
}

.user-reaction {
  width: 20px;
  height: 20px;
  margin-top: -10px;
  margin-left: 10px;
  position: relative;
}

.user-reaction img {
  /* position: absolute; */
  left: 0;
}

.follow-modal-btn {
  color: #6c2fbb;
  background-color: #ffffff;
  border: 1px solid #6c2fbb;
  border-radius: 5px;
  font-size: 12px;
  padding: 5px 10px;
}

.fullscreen#previewVideoMobile {
  height: 100% !important;
  width: 100% !important;
  left: 0;
  top: 0;
  position: fixed;
  z-index: 9999;
  right: 0;
  bottom: 0;
}

.fullscreen#previewVideoMobile .vjs-tech {
  height: 100% !important;
}

.follow-modal-btn:hover {
  background-color: #6c2fbb;
  color: #fff;
}

.user-list li img.user-reaction {
  width: 20px;
  height: 20px;
}

.user-list li p.username {
  float: left;
  font-size: 14px;
  color: #6c2fbb;
  margin-right: 10px;
  margin-left: 10px;
  margin-bottom: 0;
}

.user-list li p.reacted {
  float: left;
  font-size: 12px;
  color: #a6a3a3;
  margin-bottom: 0;
}

/* .user-list li button.btn-follow {

} */

/* Sharing modal CSS */

.sharing-modal-tabs li a {
  color: #a6a3a3 !important;
}

.sharing-modal-tabs li a.active {
  color: #6c2fbb !important;
  border-top: 3px solid #6c2fbb !important;
  border-bottom: 0!important;
}

.sharing-modal-body {
  padding: 15px;
  padding-bottom: 0px;
}

.search-users {
  margin-top: 40px;
}

.simirl-video:hover {
  color: #6c2fbb;
}

.simirl-video .svuspan {
  width: 25px;
  height: 25px;
  border-radius: 4px;
  font-size: 14px;
  min-width: auto;
  margin: 0;
}

.simirl-video .svuimg {
  width: 25px;
  height: 25px;
  border-radius: 4px;
  margin: 0;
}

.search-users form input {
  margin-right: 15px;
  width: 74%;
}

button.startOver {
  position: absolute;
  top: -30px;
  background: transparent;
  border: 0;
  padding: 0;
  padding: 5px 13px;
  font-size: 14px;
  right: 0;
  color: #fff;
  z-index: 9;
}

.share-btn {
  padding: 6px 25px !important;
  background-color: #6c2fbb;
  color: #ffffff;
  border-color: #6c2fbb;
}

.sharing-links {
  list-style-type: none;
  padding: 0;
  text-align: center;
  margin-top: 40px;
  margin-bottom: 40px;
}

.sharing-links li {
  display: inline-block;
  margin-right: 20px;
  margin-left: 20px;
  cursor: pointer;
}

.user-list-item {
  width: 100%;
  text-align: left;
  margin-right: 30px;
}

.sharing-links li img {
  width: 50px;
  height: 50px;
}

.sharing-links li p {
  font-size: 12px;
  color: #a6a3a3;
}

.p-text {
  text-align: left;
  font-size: 13px !important;
  color: #a6a3a3;
}

/* Reply modal CSS */

#reply-text {
  resize: none;
}

.reply-footer .reply-btn {
  color: #ffffff !important;
  background-color: #6c2fbb;
}

.likes-emoji {
  position: absolute;
  right: 14px;
  background-color: transparent;
}

.comment-emoji {
  position: absolute;
  width: 235px;
  z-index: 9;
  right: -3px;
  bottom: -32px;
}

.btn.mb-3.all-reply {
  margin-left: 45px;
  margin-top: -10px;
  color: #6c2fbb;
}

.cmt-usr {
  padding: 0px !important;
}

.img-pic {
  width: 32px;
  height: 32px;
  border-radius: 6px;
}

.img-nopic {
  width: 32px;
  height: 32px;
  padding-top: 5px;
  border-radius: 8px;
  text-align: center;
  color: #ffc266;
  background: #bd50d0;
  display: inline-block;
  font-size: 14px;
  font-weight: 600;
  vertical-align: middle;
  text-transform: uppercase;
}

.replies {
  display: inline-block;
  margin: 5px 0 0;
  color: #ccc;
  cursor: pointer;
}

.emoji-list {
  list-style-type: none;
  padding: 0;
  margin: 0;
  text-align: center;
  background: #fff;
  padding: 7px 10px;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.5);
  border-radius: 20px;
}

.emoji-list li {
  display: inline-block;
  margin-right: 10px;
}

.emoji-list li:hover img {
  height: 25px;
  width: 25px;
}

.emoji-list li img {
  cursor: pointer;
  width: 20px;
  height: 20px;
}

p.collapsed {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.readMore {
  margin-top: -3px !important;
  line-height: 1.4 !important;
}

.isCollapsed {
  width: 85%;
}

.video-tags {
  margin-top: 10px;
  padding: 5px;
  font-size: 12px;
  color: #878787;
}

.video-desc {
  font-size: 12px;
  text-align: justify;
}

button.reacted {
  color: #6c2fbb !important;
}

@media (max-width: 991px) {
  .search-users form input {
    margin-right: 15px;
    width: 100%;
    margin-bottom: 7px;
    margin-right: 0;
  }
  #findToshare {
    width: 100%;
  }
  .custom-container {
    padding: 0;
  }
  .optionschoiceitem {
    padding: 9px;
  }
  .custom-height {
    min-height: auto !important;
  }
  .nav-tabs .nav-item {
    margin-right: 15px;
  }
  .custom-rowa .row {
    margin: 0;
  }
  .custom-rowa .cmts-list,
  .user-commented,
  .card-container {
    padding: 15px !important;
  }
  #cmt-count-btn > .row,
  #cmt-breakdown-btn > .row {
    margin: 0;
  }
  .comment-details-sec .cmts-list > li > .media h6 {
    width: 100% !important;
  }
  .breakdown .card-container .card-row > div {
    width: 100%;
  }
  .custom-rowa .text.center {
    margin: 20px;
  }
  .optionsOFchoice {
    white-space: nowrap;
    overflow: auto;
    display: block;
    text-overflow: ellipsis;
    float: left;
    /* width: 21%; */
  }
  .comment-card-sec .card .follow-btn button {
    margin-top: 0px;
    float: none;
    margin-left: 65px;
  }
  .comment-card-sec .card .follow-btn {
    float: none;
  }
  .follow-modal-btn {
    float: right;
  }
  .user-list li p.reacted {
    margin-top: 3px;
  }
  .public-vid-comments {
    margin-top: 78px;
  }
  .breakdown .card-container .card-row > div img {
    width: 100%;
    height: auto;
  }
  .vjs-control.vjs-button {
    /* padding: 25px 0 !important; */
    font-size: 9.5px !important;
  }
}

.viwedVideo {
  border: 3px solid green;
}

.fa-arrow-down {
  position: absolute;
  left: 44%;
  top: -14px;
}

.noArrow {
  position: static !important;
}

.fa-arrow {
  position: absolute !important;
  left: 51% !important;
}

.modal-large {
  max-width: 90%;
}

.frontend-firslevel {
  width: 70px;
  height: 70px;
}

.frontend-firslevel h5 {
  font-size: 14px;
  text-align: center;
  margin-top: 5px;
}

#tree-vid-video-Modal .modal-large {
  max-width: 95%;
}

.genealogy-scroll::-webkit-scrollbar {
  width: 5px;
  height: 20px;
}

.genealogy-scroll::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: #e4e4e4;
}

.genealogy-scroll::-webkit-scrollbar-thumb {
  background: #212121;
  border-radius: 10px;
  -webkit-transition: 0.5s;
  transition: 0.5s;
}

.genealogy-scroll::-webkit-scrollbar-thumb:hover {
  background: #d5b14c;
  -webkit-transition: 0.5s;
  transition: 0.5s;
}

/*----------------genealogy-tree----------*/

.genealogy-body {
  white-space: nowrap;
  overflow-x: auto;
  /* padding: 50px; */
  padding-top: 10px;
  padding-bottom: 80px;
  text-align: center;
}

.genealogy-tree {
  margin-top: 12rem;
  display: inline-block;
  position: relative;
  z-index: 1;
}

.genealogy-tree ul {
  padding-top: 20px;
  position: relative;
  padding-left: 0px;
  display: flex;
  justify-content: center;
}

.genealogy-tree li {
  float: left;
  text-align: center;
  list-style-type: none;
  position: relative;
  padding: 20px 5px 0 5px;
}

.genealogy-tree li::before,
.genealogy-tree li::after {
  content: "";
  position: absolute;
  top: 0;
  right: 50%;
  border-top: 3px solid #d5b14c;
  width: 50%;
  height: 18px;
}

.genealogy-tree li::after {
  right: auto;
  left: 50%;
  border-left: 3px solid #d5b14c;
}

.genealogy-tree li:only-child::after,
.genealogy-tree li:only-child::before {
  display: none;
}

.genealogy-tree li:only-child {
  padding-top: 0;
}

.genealogy-tree li:first-child::before,
.genealogy-tree li:last-child::after {
  border: 0 none;
}

.genealogy-tree li:last-child::before {
  border-right: 3px solid #d5b14c;
  border-radius: 0 5px 0 0;
  -webkit-border-radius: 0 5px 0 0;
  -moz-border-radius: 0 5px 0 0;
}

.genealogy-tree li:first-child::after {
  border-radius: 5px 0 0 0;
  -webkit-border-radius: 5px 0 0 0;
  -moz-border-radius: 5px 0 0 0;
}

.genealogy-tree ul ul::before {
  content: "";
  position: absolute;
  top: 0;
  left: 50%;
  border-left: 3px solid #d5b14c;
  width: 0;
  height: 20px;
}

.genealogy-tree li a {
  text-decoration: none;
  color: #666;
  font-family: arial, verdana, tahoma;
  font-size: 11px;
  display: inline-block;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
}

/* .genealogy-tree li a:hover+ul li::before,
.genealogy-tree li a:hover+ul::before,
.genealogy-tree li a:hover+ul ul::before,
 .genealogy-tree li a:hover+ul li::after */

/* .genealogy-tree li a+ul li::before
{
    border-color:  green;
} */

/*--------------memeber-card-design----------*/

.member-view-box {
  /* padding:0px 20px; */
  text-align: center;
  border-radius: 2px;
  position: relative;
}

.member-image {
  /* width: 100px; */
  position: relative;
  z-index: 10;
  width: 150px;
}

.member-image1 {
  z-index: 12;
}

.member-image:hover {
  transform: scale(1.05);
  transition: 0.3s;
}

.member-image img {
  height: 73px;
  border-radius: 6px;
  background-color: #000;
  z-index: 1;
  border: 2px solid black;
  width: 100%;
  border-radius: 4px 4px 0px 0px;
  object-fit: fill;
}

.lock-position {
  position: absolute;
  top: 38%;
  left: 0;
  right: 0;
  width: 100%;
  color: white;
  font-size: 20px;
  color: white;
}

.child-lock-pos {
  position: absolute;
  top: 37%;
  color: white;
  right: 0;
  margin: 0 auto;
  left: 0;
  font-size: 18px;
}

/*.unViewed {
  opacity: 0.5; 
}*/

.img-fluid {
  max-width: none !important;
}

.grabbable {
  cursor: move;
  cursor: grab;
  cursor: -webkit-grab;
}

.grabbable:active {
  cursor: grabbing;
  cursor: -webkit-grabbing;
}

.child-name {
  background: #e6e6e6;
  color: black;
  font-size: 12px;
  margin: 0 auto;
  border-radius: 0px 0px 4px 4px;
  border: 1px solid #9a9a9a;
  padding: 0 2px;
  white-space: initial;
  word-break: break-word;
  line-height: 1.5;
}

.tree-conntainer {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.selected-video {
  background: #4cec5a;
  color: white;
}

.zoom-btn {
  box-shadow: 1px 1px 4px 0px rgb(0 0 0 / 20%);
  /*WC 03312022*/
  /*color: #000;*/
  font-size: 14px;
  margin: 5px;
  border: none;
  padding: 5px 13px;
  /*background: #fff;*/
  background: #6c2fbb; 
  color: #fff; 
  border-radius: 5px;
}

.zoom-btn1 {
  box-shadow: none;
  padding: 8px 32px;
  font-size: 14px;
  background: #6c2fbb;
  color: white;
  border-radius: 5px;
  border: none;
  margin-left: 0px;
  margin-top: 10px;
}

/*WC 05132022 */
.zoom-btn1::after {
  position: absolute;
  left: 235px;
  background: #5721bf !important;
  border-radius: 5px;
  padding: 17px;
  top: -5px;
  width: 244px;
  border: 2px solid #da6c31;
  color: white;
  font-size: 15px;
  z-index: 2;
}
/*WC 05132022 */

.fa-check {
  position: absolute;
  bottom: 0;
  left: 0;
  top: 15px;
  right: 0px;
  color: green;
  font-size: 25px;
  z-index: 150;
  pointer-events: none;
}

@media only screen and (max-width: 992px) {
  .video-js .vjs-tech {
    height: 100% !important;
  }
}

.video-js .vjs-tech {
  height: 100%;
}

/* @media (max-width: 768px)  {
    .public-vid-comments .video-js {
        height: 67vh;
    }
} */

@media (min-width: 492px) and (max-width: 576px) {
  .public-vid-comments .video-js {
    height: 47vh;
  }
}

@media (min-width: 576px) and (max-width: 768px) {
  .public-vid-comments .video-js {
    height: 69vh;
  }
}

@media only screen and (min-width: 652px) and (max-width: 992px) {
  .vjs-control.vjs-button[customchoices="yes"] {
    padding: 29px 5px !important;
  }
}

.tooltips {
  position: relative;
  display: inline-block;
}

.tooltips .tooltiptext {
  visibility: hidden;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  left: 137px;
  position: absolute;
  top: -168px;
  height: 257px;
  z-index: 1200;
  color: white;
}

.card-body p {
  font-size: 30px;
  padding: 5px 0px;
  /*padding: 13px 4px;*/
  /* border-bottom: 1px solid; */
}

.icon-views-upper {
  font-size: 30px;
}

.icon-align {
  align-items: center;
  color: rgb(0, 0, 0) !important;
  border-bottom: 1px solid #8080802e;
}

/* .tooltips .tooltiptext::after {
    content: '';
    position: absolute;
    top: 34%;
    left: -70px;
    margin-left: -15px;
    border-width: 50px;
    border-style: solid;
    border-color: transparent rgb(2, 2, 2) transparent transparent;
} */

.tooltiptextView {
  position: relative;
  visibility: visible !important;
}

/*.tooltiptext {
}*/

.tooltip-list ul li {
  list-style: none;
}

.tooltip-list .card {
  border-radius: 10px;
  /*height: 411px;*/
  width: 268px;
  background-color: rgb(255, 255, 255);
  color: rgb(0, 0, 0);
  margin-bottom: 5px;
}

.tooltip-list .card-body {
  padding: 0rem !important;
}

.tooltip-list .card a {
  font-size: 32px;
  border-radius: none;
  border-radius: 0;
  width: 100%;
  margin: 1px 5px;
  color: rgb(0, 0, 0);
}

.tooltip-list .card a:hover,
i:hover {
  color: rgb(243, 243, 243);
  font-weight: bold;
  transition: 0.5s;
}

.tooltip-list .card a i {
  color: #f2f2f2 !important;
}

.tooltip-list .card a i:hover {
  color: #000000 !important;
}

.fa-question-circle {
  font-size: 36px;
  color: #999999;
}

.collection-view-text {
  color: #3e3d3d;
}

.fa-info-circle {
  position: absolute;
  top: 0;
  left: 2px;
  /* color: #ff0000; */
  font-size: 25px;
}

.form-control {
  box-shadow: none;
  outline: none;
}

.copied {
  border: 1px solid green;
}

table {
  margin-bottom: 18px;
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
  border: 1px solid #ddd;
}

th,
td,
th {
  text-align: left;
  padding: 16px;
  font-size: 14px;
}

tr:nth-child(even) {
  background-color: #f2f2f2;
}

#table_header {
  background: purple;
  color: white;
  font-size: 14px;
  height: 53px !important;
  box-shadow: 0px 0px 5px 0px rgb(0 0 0 / 20%);
}

.coll-btn {
  padding: 4px 32px;
  font-size: 14px;
  background: #6c2fbb;
  color: white;
  border-radius: 5px;
  float: right;
  outline: none;
  border: none;
  margin-bottom: 29px;
}

.para-txt {
  font-size: 15px;
  color: #1f1212a8;
}

.table-view {
  height: 276px;
  overflow: scroll;
  margin-bottom: 24px;
  border: 1px solid #80808029;
  cursor: pointer;
}

.current-topic {
  font-size: 19px;
  font-weight: 600;
}

.question-view {
  font-size: 22px;
  position: absolute !important;
  left: 0px;
  top: -2px;
  color: #ba65cc;
  background: #ffffff;
  padding: 6px;
  /* border-radius: 50%; */
  width: 32px;
  height: 32px;
}

.comment-count {
  position: absolute;
  top: 0px;
  font-size: 18px;
  color: #d2ba45;
  width: 28px;
  height: 28px;
  right: 0px;
  border: 1px solid #d2ba45;
  background-color: white;
}

.fa-infos {
  font-size: 22px;
  position: absolute;
  left: 0px;
  top: 0px;
  background: white;
  padding: 14px;
  height: 28px;
  width: 28px;
}

.fa-infos img {
  background: none !important;
  height: 28px !important;
  border: none !important;
  background: white !important;
  padding: 2px !important;
  width: 28px !important;
  position: absolute !important;
  left: 0;
  top: 0;
}

.share-view {
  padding-left: 0 !important;
  margin: 0;
}

.test-class {
  display: none;
  position: absolute;
  right: -195px;
  background: none;
  top: -10px;
  color: white;
  padding: 8px;
  box-sizing: border-box;
  z-index: 9999;
  background-color: white;
}

.view-login {
  display: block !important;
}

.test-class button {
  border: none;
  background: #8700ff;
  color: white;
  padding: 2px 29px;
  border-radius: 6px;
  font-size: 22px;
}

.test-class p {
  color: rgb(8 8 8);
  font-weight: bold;
  margin-bottom: 2px;
  font-size: 23px;
}

/*.tooltip-content {
  padding-left: 1.5rem !important; 
}*/

.pl-2 {
  padding-left: 1.5rem !important;
}

.is-selceted {
  background-color: purple !important;
  opacity: 0.8;
  color: white;
}

.fa-exclamation {
  position: relative;
  right: 1px;
}

.fa-info-circle {
  position: relative;
  top: 0;
  left: -8px;
  font-size: 32px;
}

.fa-question {
  position: relative;
  right: 3px;
}

.fa-comment-alt {
  position: relative;
  right: 3px;
}

.fa-share {
  position: relative;
  right: 3px;
}

.fa-hands {
  position: relative;
  right: 5px;
}

.help-box {
  position: absolute;
  left: 175px;
  background: #5721bf !important;
  border-radius: 5px;
  padding: 17px;
  top: 55px;
  width: 244px;
  border: 2px solid #da6c31;
  color: white;
  font-size: 15px;
  z-index: 2;
}

.wc-help-box {
  position: absolute;
  left: 190px;
  background: #5721bf !important;
  border-radius: 5px;
  padding: 17px;
  top: 0px;
  width: 350px;
  border: 2px solid #da6c31;
  color: white;
  font-size: 15px;
  z-index: 2;
}

.help-box::after {
  content: "";
  position: absolute;
  top: 5%;
  right: 100%;
  margin-top: 0;
  border-width: 15px;
  border-style: solid;
  border-color: transparent #da6c31 transparent transparent;
  height: 24px;
}

.wc-help-box::after {
  content: "";
  position: absolute;
  top: 4%;
  left: 100%;
  margin-top: 0;
  border-width: 15px;
  border-style: solid;
  border-color: transparent #da6c31 transparent transparent;
  height: 24px;
  transform: rotate(180deg);
}

.fa-times-circle {
  position: absolute;
  right: 10px;
  cursor: pointer;
}

.OK {
  text-align: right;
  margin-bottom: 0;
  padding: 0;
  cursor: pointer;
}

.private-badge {
  color: #6c2fbb;
  padding: 5px 15px;
  border: 1px solid #6c2fbb;
  background: #fff;
  border-radius: 12px;
}

/* WC 05132022 */

@media (max-width: 767px) {
  .help-box {
    position: absolute;
    left: 200px;
    background: #5721bf !important;
    border-radius: 5px;
    padding: 17px;
    top: 50px;
    width: 150px;
    border: 2px solid #da6c31;
    color: white;
    font-size: 15px;
    z-index: 2;
  }

  .help-box::after {
    content: "";
    position: absolute;
    top: 0%;
    left: -25%;
    margin-top: 0;
    border-width: 15px;
    border-style: solid;
    border-color: transparent #da6c31 transparent transparent;
    height: 24px;
    /*transform: rotate(90deg);*/
  }

  .wc-help-box {
    position: absolute;
    left: 0px;
    background: #5721bf !important;
    border-radius: 5px;
    padding: 15px;
    top: 40px;
    width: 300px;
    border: 2px solid #da6c31;
    color: white;
    font-size: 15px;
    z-index: 2;
  }

  .wc-help-box::after {
    content: "";
    position: absolute;
    top: -18%;
    left: 45%;
    margin-top: 0;
    border-width: 15px;
    border-style: solid;
    border-color: transparent #da6c31 transparent transparent;
    height: 24px;
    transform: rotate(90deg);
  }
}

@media (max-width: 576px) { 
  .help-box {
    position: absolute;
    left: 180px;
    background: #5721bf !important;
    border-radius: 5px;
    padding: 17px;
    top: 40px;
    width: 150px;
    border: 2px solid #da6c31;
    color: white;
    font-size: 15px;
    z-index: 2;
  }

  .help-box::after {
    content: "";
    position: absolute;
    top: 0%;
    left: -25%;
    margin-top: 0;
    border-width: 15px;
    border-style: solid;
    border-color: transparent #da6c31 transparent transparent;
    height: 24px;
    /*transform: rotate(90deg);*/
  }

  .wc-help-box {
    position: absolute;
    left: 0px;
    background: #5721bf !important;
    border-radius: 5px;
    padding: 15px;
    top: 40px;
    width: 300px;
    border: 2px solid #da6c31;
    color: white;
    font-size: 15px;
    z-index: 2;
  }

  .wc-help-box::after {
    content: "";
    position: absolute;
    top: -18%;
    left: 45%;
    margin-top: 0;
    border-width: 15px;
    border-style: solid;
    border-color: transparent #da6c31 transparent transparent;
    height: 24px;
    transform: rotate(90deg);
  }

  .btn-mania {
    color: #6c2fbb;
    border: 1px solid #6c2fbb;
    padding: 4px 12px;
    font-size: 12px;
    font-weight: 500;
    background: #FFFFFF;
    border-radius: 11px;
    /*margin: 5px 7px;*/
    white-space: nowrap;
  }

}

.miniPlayer .custom-height {
  height: 100% !important;
}

.close-mini-player {
  display: none;
  box-shadow: none !important;
  position: absolute;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  top: 20px;
  right: 25px;
  font-size: 16px;
}

.miniPlayer:hover .close-mini-player {
  display: block;
}

.miniPlayer {
  z-index: 999;
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 425px;
  height: 225px;
  padding: 15px;
  box-shadow: 0px 11px 15px -7px rgb(0 0 0 / 20%), 0px 24px 38px 3px rgb(0 0 0 / 14%), 0px 9px 46px 8px rgb(0 0 0 / 12%);
  background: #fff;
  color: rgba(0, 0, 0, .87);
  border-radius: 4px;
  overflow: auto;
}

@media (max-width: 475px) {
  .close-mini-player {
    top: 11px;
    right: 11px;
    font-size: 14px;
  }

  .miniPlayer {
    width: 50%;
    height: 125px;
    right: 1px;
    padding: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/afterLogin/public-video/public-video.component.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;;AAEA,6BAA6B;;AAE7B;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB,sBAAsB;AACtB,IAAI;;AAEJ;EACE,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;;EAEhB,eAAe;EACf;;oBAEkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,4BAA4B;EAC5B,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;;EAEf,kBAAkB;IAChB,eAAe;IACf,gBAAgB;EAClB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,UAAU;EACV,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,UAAU;EACV,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA,gBAAgB;;AAEhB;;EAEE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;;;EAGE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;EACnC,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;AACd;;AAEA,gBAAgB;;AAEhB,gCAAgC;;AAEhC;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gCAAgC;;AAEhC;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,sBAAsB;EACtB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,sCAAsC;EACtC,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,UAAU;AACZ;;AAEA,6BAA6B;;AAE7B,8BAA8B;;AAE9B;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,8BAA8B;;AAE9B;EACE,aAAa;EACb,eAAe;EACf,wBAAwB;EACxB,WAAW;EACX,wBAAwB;EACxB,yBAAyB;EACzB,8CAA8C;EAC9C,eAAe;EACf,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,UAAU;EACV,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,oBAAoB;;AAEpB;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,gBAAgB;EAChB,8BAA8B;EAC9B,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,WAAW;EACX,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,OAAO;AACT;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,OAAO;EACP,MAAM;EACN,eAAe;EACf,aAAa;EACb,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;;GAEG;;AAEH,sBAAsB;;AAEtB;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;EACxC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,eAAe;EACf,QAAQ;EACR,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA,oBAAoB;;AAEpB;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,WAAW;EACX,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,SAAS;EACX;EACA;;;IAGE,wBAAwB;EAC1B;EACA;;IAEE,SAAS;EACX;EACA;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,mBAAmB;IACnB,cAAc;IACd,cAAc;IACd,uBAAuB;IACvB,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,WAAW;IACX,iBAAiB;EACnB;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,gCAAgC;IAChC,2BAA2B;EAC7B;AACF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,wBAAgB;EAAhB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,wBAAgB;EAAhB,gBAAgB;AAClB;;AAEA,2CAA2C;;AAE3C;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,6BAA6B;EAC7B,UAAU;EACV,YAAY;AACd;;AAEA;EACE,WAAW;EACX,SAAS;EACT,8BAA8B;AAChC;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,wBAAwB;EACxB,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,8BAA8B;EAC9B,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,mCAAmC;EACnC,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;;;0CAG0C;;AAE1C;;;GAGG;;AAEH,8CAA8C;;AAE9C;EACE,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,UAAU;EACV,uBAAuB;EACvB,WAAW;EACX,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,QAAQ;EACR,cAAc;EACd,OAAO;EACP,eAAe;AACjB;;AAEA;;EAEE;;AAEF;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,YAAY;EAEZ,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAEhB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,8BAA8B;EAC9B,yBAAyB;EACzB,cAAc;EACd,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,4CAA4C;EAC5C,cAAc;EACd,eAAe;EACf,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,WAAW;EACX,8BAA8B;EAC9B,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,UAAU;AACZ;AACA,eAAe;;AAEf;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,SAAS;EACT,UAAU;EACV,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,YAAY;AACd;;AAEA;;;;GAIG;;AAEH;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,aAAa;EACb,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;;;;;;;;;GASG;;AAEH;EACE,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE;;AAEF;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;EACX,sBAAsB;AACxB;;AAEA;;;EAGE,gBAAgB;EAChB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,SAAS;EACT,SAAS;EACT,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,iBAAiB;EACjB,aAAa;EACb,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,uBAAuB;EACvB,4BAA4B;EAC5B,uBAAuB;EACvB,sBAAsB;EACtB,6BAA6B;EAC7B,OAAO;EACP,MAAM;AACR;;AAEA;EACE,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE;;AAEF;EACE,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;EACnC,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,8BAA8B;EAC9B,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,8BAA8B;EAC9B,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,yDAAyD;EACzD,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,UAAU;EACV,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,yDAAyD;EACzD,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,gBAAgB;;AAEhB;EACE;IACE,kBAAkB;IAClB,WAAW;IACX,8BAA8B;IAC9B,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,yDAAyD;IACzD,YAAY;IACZ,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,8BAA8B;IAC9B,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,yDAAyD;IACzD,YAAY;IACZ,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,WAAW;IACX,8BAA8B;IAC9B,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,yDAAyD;IACzD,YAAY;IACZ,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,8BAA8B;IAC9B,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,yDAAyD;IACzD,YAAY;IACZ,wBAAwB;EAC1B;;EAEA;IACE,cAAc;IACd,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;EACrB;;AAEF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sHAAsH;EACtH,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE;IACE,SAAS;IACT,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,aAAa;IACb,UAAU;IACV,aAAa;EACf;AACF","sourcesContent":["html {\r\n  scroll-behavior: smooth;\r\n}\r\n\r\n/* Public Video Comment css */\r\n\r\n.profile-image {\r\n  width: 50px;\r\n  min-width: 50px;\r\n  height: 50px;\r\n  font-size: 22px;\r\n  line-height: 30px;\r\n  margin-right: 10px;\r\n}\r\n\r\nbody {\r\n  margin-bottom: 50px;\r\n}\r\n\r\n/*.public-vid-comments {*/\r\n/*  margin-top: 45px;*/\r\n/*}*/\r\n\r\n.embed {\r\n  margin-top: 1px !important;\r\n}\r\n\r\n.custom-container {\r\n  /*padding-left: 8%;*/\r\n  /*padding-right: 4%;*/\r\n}\r\n.customEmbed {\r\n  padding-left: 0px !important;\r\n  padding-right: 0px !important;\r\n}\r\n\r\n.comment-card-sec .card .vid-info h3 {\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n\r\n  /*WC 05132022 */\r\n  /*overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  max-width: 300px;*/\r\n  /*WC 05132022 */\r\n}\r\n\r\n.comment-card-sec .card .vid-info p,\r\n.comment-card-sec .card .follow-area p {\r\n  font-size: 15px;\r\n}\r\n\r\na.cmt-show-more {\r\n  font-size: 15px;\r\n  color: #6c2fbb !important;\r\n}\r\n\r\n.comment-card-sec .card .vid-info p:nth-of-type(2) {\r\n  margin-top: 15px !important;\r\n  font-size: 15px;\r\n}\r\n\r\n.pro-group h6 {\r\n  font-size: 14px;\r\n}\r\n\r\n.custom-react-button {\r\n  position: relative;\r\n  text-align: CENTER !important;\r\n  margin-left: 10px !important;\r\n  padding: 4px 10px !important;\r\n  background: #e8e8e8 !important;\r\n}\r\n\r\n.follow-share {\r\n  padding: 5px 20px;\r\n  font-size: 14px;\r\n  position: relative;\r\n  /*margin-bottom: 15px;*/\r\n  cursor: pointer;\r\n\r\n  border-radius: 8px;\r\n    /*width: 45px;*/\r\n    /*height: 45px;*/\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 3px;\r\n}\r\n\r\n.follow-share img {\r\n  border-radius: 10px;\r\n  min-width: 50px;\r\n  /*position: absolute;*/\r\n  /*left: 20px;*/\r\n  /*top: 0;*/\r\n  object-fit: cover;\r\n  margin-right: 10px;\r\n}\r\n\r\n.follow-share h5 {\r\n  font-size: 14px;\r\n  /*padding-left: 60px;*/\r\n  /*margin-top: 12px;*/\r\n  margin-bottom: 0;\r\n}\r\n\r\n.follow-share.selected-share:before {\r\n  content: \"\\2713\";\r\n  display: inline-block;\r\n  color: #fff;\r\n  position: absolute;\r\n  top: 5px;\r\n  align-items: center;\r\n  text-align: center;\r\n  left: 20px;\r\n  background: #6c2fbb;\r\n  width: 50px;\r\n  height: 50px;\r\n  /*border-radius: 50%;*/\r\n  border-radius: 10px;\r\n  font-size: 30px;\r\n  z-index: 9;\r\n  opacity: 0.7;\r\n  line-height: 52px;\r\n}\r\n\r\n.follow-share.selected-share h5 {\r\n  color: #6c2fbb;\r\n}\r\n\r\n.comment-card-sec .card .like-btn button img {\r\n  height: 24px;\r\n}\r\n\r\n.comment-card-sec .card .option-btns button {\r\n  font-size: 15px;\r\n  padding: 4px;\r\n  box-shadow: unset;\r\n}\r\n\r\n.comment-card-sec .card .option-btns button img {\r\n  margin-left: 10px;\r\n  width: 14px;\r\n  height: 14px;\r\n}\r\n\r\n.comment-card-sec .card .option-btns,\r\n.comment-card-sec .card .like-btn {\r\n  text-align: end;\r\n}\r\n\r\n.comment-card-sec .card .like-btn {\r\n  float: right;\r\n}\r\n\r\n.comment-card-sec .card .follow-area h5 {\r\n  font-size: 16px;\r\n  color: #6c2fbb;\r\n}\r\n\r\n.comment-card-sec .card .follow-btn {\r\n  float: right;\r\n}\r\n\r\n.comment-card-sec .card .follow-btn button {\r\n  padding: 4px 32px;\r\n  font-size: 14px;\r\n  background: #6c2fbb;\r\n  color: white;\r\n  border-radius: 5px;\r\n  float: right;\r\n  margin-top: 20px;\r\n}\r\n\r\n/* Comment css */\r\n\r\n.comment-details-sec .cmts-list,\r\n.comment-details-sec .reply-list {\r\n  list-style-type: none;\r\n}\r\n\r\n.comment-details-sec .cmts-list > li > .media h6 {\r\n  font-size: 17px;\r\n  font-weight: 500;\r\n}\r\n\r\n.comment-details-sec .cmts-list > li > .media p {\r\n  font-size: 15px;\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.comment-details-sec .cmts-list > li > .media .cmt-opt {\r\n  font-size: 15px;\r\n}\r\n\r\n.comment-details-sec .cmts-list > li > .media h6 span {\r\n  font-size: 15px;\r\n  font-weight: normal;\r\n  color: #a6a3a3;\r\n}\r\n\r\n.comment-details-sec .cmts-list > li .reply-list li .media h6 {\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n}\r\n\r\n.comment-details-sec .cmts-list > li .reply-list li .media {\r\n  font-size: 15px;\r\n}\r\n\r\n.comment-details-sec .cmts-list > li .reply-list li .media h6 span {\r\n  font-size: 14px;\r\n  font-weight: normal;\r\n  color: #a6a3a3;\r\n}\r\n\r\n.comment-details-sec .user-commented h4 {\r\n  font-size: 19px;\r\n}\r\n\r\n.comment-details-sec .user-commented > ul {\r\n  list-style-type: none;\r\n  padding-left: 0;\r\n}\r\n\r\n.comment-details-sec .user-commented > ul li span .cb {\r\n  width: 5px;\r\n  height: 5px;\r\n  display: inline-block;\r\n  border-radius: 50%;\r\n}\r\n\r\n.cmts-list .reply-list .all-reply,\r\n.user-commented ul .show-more,\r\n.cmts-list > li > .media .cmt-reply button {\r\n  color: #6c2fbb;\r\n  font-size: 15px;\r\n  padding-left: 0px;\r\n  box-shadow: none;\r\n}\r\n\r\n.comment-details-sec .form-group.write-cmt > label {\r\n  border-radius: 50%;\r\n  padding: 8px;\r\n  margin-bottom: 0px;\r\n  font-size: 10px;\r\n  background: lightslategray;\r\n  color: white;\r\n  position: absolute;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  left: 2%;\r\n}\r\n\r\n.comment-details-sec .form-group.write-cmt > input {\r\n  height: 50px;\r\n  border: 1px solid #f4f1f1;\r\n}\r\n\r\n.comment-details-sec .like-cmt-select > span {\r\n  position: absolute;\r\n  font-size: 13px;\r\n  left: 15px;\r\n  top: 2px;\r\n  color: #878787;\r\n}\r\n\r\n.comment-details-sec .like-cmt-select > select {\r\n  height: 50px;\r\n  font-size: 15px;\r\n}\r\n\r\n.comment-details-sec .like-cmt-select button {\r\n  position: absolute;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  right: 2px;\r\n  width: 50px;\r\n  background-color: #f5f7f6;\r\n}\r\n\r\n.comment-details-sec .like-cmt-select button span {\r\n  border-left: 5px solid transparent;\r\n  border-right: 5px solid transparent;\r\n  border-top: 6px solid #555;\r\n  display: inline-block;\r\n}\r\n\r\n.comment-card-sec .cmt-tab-btns > ul li a.active {\r\n  color: black;\r\n  border-bottom: 3px solid black;\r\n}\r\n\r\n.comment-card-sec .cmt-tab-btns > ul li a {\r\n  color: #495057;\r\n  padding: 8px 0px;\r\n}\r\n\r\n.comment-card-sec .cmt-tab-btns > ul,\r\n.comment-card-sec .cmt-tab-btns > ul li a {\r\n  border: none;\r\n}\r\n\r\n/* Comment css */\r\n\r\n/* choise sec bullet color css */\r\n\r\n.cmt-bullet-c1 {\r\n  background: #6c2fbb;\r\n}\r\n\r\n.cmt-bullet-c2 {\r\n  background: #dfbd5b;\r\n}\r\n\r\n.cmt-bullet-c3 {\r\n  background: #65cf9c;\r\n}\r\n\r\n.cmt-bullet-c4 {\r\n  background: #d14870;\r\n}\r\n\r\n/* choise sec bullet color end */\r\n\r\n.row.breakdown h4 {\r\n  font-size: 20px;\r\n}\r\n\r\n.breakdown .progress-container .pro-group .progress {\r\n  height: 6px;\r\n}\r\n\r\n.breakdown .progress-container .progress .progress-bar {\r\n  background-color: #6c2fbb;\r\n}\r\n\r\n.breakdown .card-container .card-row {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n}\r\n.breakdown .card-container .top-card-title {\r\n  position: absolute;\r\n  top: -10px;\r\n  left: 0px;\r\n  color: #fff !important;\r\n  background: #0000007d;\r\n  border: 4px;\r\n  padding: 5px;\r\n  border-radius: 3px;\r\n}\r\n\r\n.breakdown .card-container .card-row > div {\r\n  /* width: calc(25% - 12px); */\r\n  width: auto;\r\n  margin: 0px 12px 12px 0px;\r\n  position: relative;\r\n}\r\n\r\n.breakdown .card-container .card-row > div img {\r\n  width: 190px;\r\n  height: 150px;\r\n  object-fit: cover;\r\n}\r\n\r\n.breakdown .card-container .card-row > div h6 {\r\n  margin-top: 10px;\r\n  color: #000;\r\n  word-break: break-all;\r\n  font-size: 14px;\r\n}\r\n\r\n.vid-cover .cmt-toast .toast-header > button {\r\n  font-size: 20px;\r\n}\r\n\r\n.comment-card-sec .vid-cover .cmt-toast {\r\n  position: absolute;\r\n  top: 10px;\r\n  left: 12px;\r\n}\r\n\r\n.video-player-image {\r\n  width: 100%;\r\n  height: 70vh;\r\n}\r\n\r\n.video-control-bar {\r\n  position: absolute;\r\n  bottom: 0;\r\n  left: 0;\r\n  right: 0;\r\n  width: 100%;\r\n  background-color: rgba(43, 51, 63, .7);\r\n  transition: 0.4s ease-in-out all;\r\n  display: flex;\r\n  visibility: visible;\r\n  opacity: 1;\r\n}\r\n\r\n/* Public Video Comment css */\r\n\r\n/* Private Video Comment css */\r\n\r\n.comment-card-sec .vid-menu {\r\n  background: black;\r\n  border-top: 1px solid #ffffff80;\r\n  min-height: 50px;\r\n}\r\n\r\n.comment-card-sec .vid-menu > button {\r\n  width: 100%;\r\n  color: white;\r\n  border-right: 1px solid #ffffff80;\r\n  border-radius: 0;\r\n  transition: all 0.2s linear;\r\n}\r\n\r\n.comment-card-sec .vid-menu > button:last-child {\r\n  border-right: none;\r\n}\r\n\r\n.comment-card-sec .vid-menu > button:hover {\r\n  background-color: #6c2fbb;\r\n}\r\n\r\n/* Private Video Comment css */\r\n\r\n.optionschoiceitem {\r\n  padding: 25px;\r\n  font-size: 16px;\r\n  /* border-radius: 5px; */\r\n  color: #fff;\r\n  /* margin-right: 10px; */\r\n  /* margin-bottom: 10px; */\r\n  box-shadow: 1px 1px 4px 1px rgba(0, 0, 0, 0.5);\r\n  cursor: pointer;\r\n  display: table-cell;\r\n  letter-spacing: 0.5px;\r\n}\r\n\r\n.optionschoiceitem:hover {\r\n  background: #726bfa;\r\n}\r\n\r\n.optionsOFchoice {\r\n  opacity: 0.8;\r\n  background: rgba(0, 0, 0, 0.8);\r\n  z-index: 9;\r\n  position: relative;\r\n  display: table;\r\n  width: 100%;\r\n  text-align: center;\r\n  background: #000;\r\n}\r\n\r\n/* React modal CSS */\r\n\r\n.gray-border-bottom {\r\n  border-bottom: 1px solid #dee2e6;\r\n}\r\n\r\n.react-modal-tabs {\r\n  text-align: center;\r\n}\r\n\r\n.react-modal-tabs li a img {\r\n  width: 20px;\r\n  height: 20px;\r\n}\r\n\r\n.react-modal-tabs li a p {\r\n  margin-bottom: 0;\r\n  font-size: 12px;\r\n}\r\n\r\n.user-list {\r\n  list-style-type: none;\r\n  padding: 0;\r\n  margin-top: 10px;\r\n  margin-bottom: 10px !important;\r\n  max-height: 300px;\r\n  overflow: auto;\r\n}\r\n\r\n.user-list li {\r\n  margin-bottom: 15px;\r\n  padding-bottom: 54px;\r\n  border-bottom: 1px solid #ccc;\r\n}\r\n\r\n.user-list li img.user-profile-pic {\r\n  float: left;\r\n  width: 40px;\r\n  height: 40px;\r\n  border-radius: 50%;\r\n  object-fit: cover;\r\n}\r\n\r\n.left-image {\r\n  width: 40px;\r\n  height: 40px;\r\n  float: left;\r\n  /* background-color: red; */\r\n}\r\n\r\n.right-section {\r\n  width: calc(100% - 40px);\r\n  height: 40px;\r\n  float: left;\r\n  /* background-color: teal; */\r\n  color: #fff;\r\n}\r\n\r\n.user-reaction {\r\n  width: 20px;\r\n  height: 20px;\r\n  margin-top: -10px;\r\n  margin-left: 10px;\r\n  position: relative;\r\n}\r\n\r\n.user-reaction img {\r\n  /* position: absolute; */\r\n  left: 0;\r\n}\r\n\r\n.follow-modal-btn {\r\n  color: #6c2fbb;\r\n  background-color: #ffffff;\r\n  border: 1px solid #6c2fbb;\r\n  border-radius: 5px;\r\n  font-size: 12px;\r\n  padding: 5px 10px;\r\n}\r\n\r\n.fullscreen#previewVideoMobile {\r\n  height: 100% !important;\r\n  width: 100% !important;\r\n  left: 0;\r\n  top: 0;\r\n  position: fixed;\r\n  z-index: 9999;\r\n  right: 0;\r\n  bottom: 0;\r\n}\r\n\r\n.fullscreen#previewVideoMobile .vjs-tech {\r\n  height: 100% !important;\r\n}\r\n\r\n.follow-modal-btn:hover {\r\n  background-color: #6c2fbb;\r\n  color: #fff;\r\n}\r\n\r\n.user-list li img.user-reaction {\r\n  width: 20px;\r\n  height: 20px;\r\n}\r\n\r\n.user-list li p.username {\r\n  float: left;\r\n  font-size: 14px;\r\n  color: #6c2fbb;\r\n  margin-right: 10px;\r\n  margin-left: 10px;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.user-list li p.reacted {\r\n  float: left;\r\n  font-size: 12px;\r\n  color: #a6a3a3;\r\n  margin-bottom: 0;\r\n}\r\n\r\n/* .user-list li button.btn-follow {\r\n\r\n} */\r\n\r\n/* Sharing modal CSS */\r\n\r\n.sharing-modal-tabs li a {\r\n  color: #a6a3a3 !important;\r\n}\r\n\r\n.sharing-modal-tabs li a.active {\r\n  color: #6c2fbb !important;\r\n  border-top: 3px solid #6c2fbb !important;\r\n  border-bottom: 0!important;\r\n}\r\n\r\n.sharing-modal-body {\r\n  padding: 15px;\r\n  padding-bottom: 0px;\r\n}\r\n\r\n.search-users {\r\n  margin-top: 40px;\r\n}\r\n\r\n.simirl-video:hover {\r\n  color: #6c2fbb;\r\n}\r\n\r\n.simirl-video .svuspan {\r\n  width: 25px;\r\n  height: 25px;\r\n  border-radius: 4px;\r\n  font-size: 14px;\r\n  min-width: auto;\r\n  margin: 0;\r\n}\r\n\r\n.simirl-video .svuimg {\r\n  width: 25px;\r\n  height: 25px;\r\n  border-radius: 4px;\r\n  margin: 0;\r\n}\r\n\r\n.search-users form input {\r\n  margin-right: 15px;\r\n  width: 74%;\r\n}\r\n\r\nbutton.startOver {\r\n  position: absolute;\r\n  top: -30px;\r\n  background: transparent;\r\n  border: 0;\r\n  padding: 0;\r\n  padding: 5px 13px;\r\n  font-size: 14px;\r\n  right: 0;\r\n  color: #fff;\r\n  z-index: 9;\r\n}\r\n\r\n.share-btn {\r\n  padding: 6px 25px !important;\r\n  background-color: #6c2fbb;\r\n  color: #ffffff;\r\n  border-color: #6c2fbb;\r\n}\r\n\r\n.sharing-links {\r\n  list-style-type: none;\r\n  padding: 0;\r\n  text-align: center;\r\n  margin-top: 40px;\r\n  margin-bottom: 40px;\r\n}\r\n\r\n.sharing-links li {\r\n  display: inline-block;\r\n  margin-right: 20px;\r\n  margin-left: 20px;\r\n  cursor: pointer;\r\n}\r\n\r\n.user-list-item {\r\n  width: 100%;\r\n  text-align: left;\r\n  margin-right: 30px;\r\n}\r\n\r\n.sharing-links li img {\r\n  width: 50px;\r\n  height: 50px;\r\n}\r\n\r\n.sharing-links li p {\r\n  font-size: 12px;\r\n  color: #a6a3a3;\r\n}\r\n\r\n.p-text {\r\n  text-align: left;\r\n  font-size: 13px !important;\r\n  color: #a6a3a3;\r\n}\r\n\r\n/* Reply modal CSS */\r\n\r\n#reply-text {\r\n  resize: none;\r\n}\r\n\r\n.reply-footer .reply-btn {\r\n  color: #ffffff !important;\r\n  background-color: #6c2fbb;\r\n}\r\n\r\n.likes-emoji {\r\n  position: absolute;\r\n  right: 14px;\r\n  background-color: transparent;\r\n}\r\n\r\n.comment-emoji {\r\n  position: absolute;\r\n  width: 235px;\r\n  z-index: 9;\r\n  right: -3px;\r\n  bottom: -32px;\r\n}\r\n\r\n.btn.mb-3.all-reply {\r\n  margin-left: 45px;\r\n  margin-top: -10px;\r\n  color: #6c2fbb;\r\n}\r\n\r\n.cmt-usr {\r\n  padding: 0px !important;\r\n}\r\n\r\n.img-pic {\r\n  width: 32px;\r\n  height: 32px;\r\n  border-radius: 6px;\r\n}\r\n\r\n.img-nopic {\r\n  width: 32px;\r\n  height: 32px;\r\n  padding-top: 5px;\r\n  border-radius: 8px;\r\n  text-align: center;\r\n  color: #ffc266;\r\n  background: #bd50d0;\r\n  display: inline-block;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  vertical-align: middle;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.replies {\r\n  display: inline-block;\r\n  margin: 5px 0 0;\r\n  color: #ccc;\r\n  cursor: pointer;\r\n}\r\n\r\n.emoji-list {\r\n  list-style-type: none;\r\n  padding: 0;\r\n  margin: 0;\r\n  text-align: center;\r\n  background: #fff;\r\n  padding: 7px 10px;\r\n  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.5);\r\n  border-radius: 20px;\r\n}\r\n\r\n.emoji-list li {\r\n  display: inline-block;\r\n  margin-right: 10px;\r\n}\r\n\r\n.emoji-list li:hover img {\r\n  height: 25px;\r\n  width: 25px;\r\n}\r\n\r\n.emoji-list li img {\r\n  cursor: pointer;\r\n  width: 20px;\r\n  height: 20px;\r\n}\r\n\r\np.collapsed {\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.readMore {\r\n  margin-top: -3px !important;\r\n  line-height: 1.4 !important;\r\n}\r\n\r\n.isCollapsed {\r\n  width: 85%;\r\n}\r\n\r\n.video-tags {\r\n  margin-top: 10px;\r\n  padding: 5px;\r\n  font-size: 12px;\r\n  color: #878787;\r\n}\r\n\r\n.video-desc {\r\n  font-size: 12px;\r\n  text-align: justify;\r\n}\r\n\r\nbutton.reacted {\r\n  color: #6c2fbb !important;\r\n}\r\n\r\n@media (max-width: 991px) {\r\n  .search-users form input {\r\n    margin-right: 15px;\r\n    width: 100%;\r\n    margin-bottom: 7px;\r\n    margin-right: 0;\r\n  }\r\n  #findToshare {\r\n    width: 100%;\r\n  }\r\n  .custom-container {\r\n    padding: 0;\r\n  }\r\n  .optionschoiceitem {\r\n    padding: 9px;\r\n  }\r\n  .custom-height {\r\n    min-height: auto !important;\r\n  }\r\n  .nav-tabs .nav-item {\r\n    margin-right: 15px;\r\n  }\r\n  .custom-rowa .row {\r\n    margin: 0;\r\n  }\r\n  .custom-rowa .cmts-list,\r\n  .user-commented,\r\n  .card-container {\r\n    padding: 15px !important;\r\n  }\r\n  #cmt-count-btn > .row,\r\n  #cmt-breakdown-btn > .row {\r\n    margin: 0;\r\n  }\r\n  .comment-details-sec .cmts-list > li > .media h6 {\r\n    width: 100% !important;\r\n  }\r\n  .breakdown .card-container .card-row > div {\r\n    width: 100%;\r\n  }\r\n  .custom-rowa .text.center {\r\n    margin: 20px;\r\n  }\r\n  .optionsOFchoice {\r\n    white-space: nowrap;\r\n    overflow: auto;\r\n    display: block;\r\n    text-overflow: ellipsis;\r\n    float: left;\r\n    /* width: 21%; */\r\n  }\r\n  .comment-card-sec .card .follow-btn button {\r\n    margin-top: 0px;\r\n    float: none;\r\n    margin-left: 65px;\r\n  }\r\n  .comment-card-sec .card .follow-btn {\r\n    float: none;\r\n  }\r\n  .follow-modal-btn {\r\n    float: right;\r\n  }\r\n  .user-list li p.reacted {\r\n    margin-top: 3px;\r\n  }\r\n  .public-vid-comments {\r\n    margin-top: 78px;\r\n  }\r\n  .breakdown .card-container .card-row > div img {\r\n    width: 100%;\r\n    height: auto;\r\n  }\r\n  .vjs-control.vjs-button {\r\n    /* padding: 25px 0 !important; */\r\n    font-size: 9.5px !important;\r\n  }\r\n}\r\n\r\n.viwedVideo {\r\n  border: 3px solid green;\r\n}\r\n\r\n.fa-arrow-down {\r\n  position: absolute;\r\n  left: 44%;\r\n  top: -14px;\r\n}\r\n\r\n.noArrow {\r\n  position: static !important;\r\n}\r\n\r\n.fa-arrow {\r\n  position: absolute !important;\r\n  left: 51% !important;\r\n}\r\n\r\n.modal-large {\r\n  max-width: 90%;\r\n}\r\n\r\n.frontend-firslevel {\r\n  width: 70px;\r\n  height: 70px;\r\n}\r\n\r\n.frontend-firslevel h5 {\r\n  font-size: 14px;\r\n  text-align: center;\r\n  margin-top: 5px;\r\n}\r\n\r\n#tree-vid-video-Modal .modal-large {\r\n  max-width: 95%;\r\n}\r\n\r\n.genealogy-scroll::-webkit-scrollbar {\r\n  width: 5px;\r\n  height: 20px;\r\n}\r\n\r\n.genealogy-scroll::-webkit-scrollbar-track {\r\n  border-radius: 10px;\r\n  background-color: #e4e4e4;\r\n}\r\n\r\n.genealogy-scroll::-webkit-scrollbar-thumb {\r\n  background: #212121;\r\n  border-radius: 10px;\r\n  transition: 0.5s;\r\n}\r\n\r\n.genealogy-scroll::-webkit-scrollbar-thumb:hover {\r\n  background: #d5b14c;\r\n  transition: 0.5s;\r\n}\r\n\r\n/*----------------genealogy-tree----------*/\r\n\r\n.genealogy-body {\r\n  white-space: nowrap;\r\n  overflow-x: auto;\r\n  /* padding: 50px; */\r\n  padding-top: 10px;\r\n  padding-bottom: 80px;\r\n  text-align: center;\r\n}\r\n\r\n.genealogy-tree {\r\n  margin-top: 12rem;\r\n  display: inline-block;\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n\r\n.genealogy-tree ul {\r\n  padding-top: 20px;\r\n  position: relative;\r\n  padding-left: 0px;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.genealogy-tree li {\r\n  float: left;\r\n  text-align: center;\r\n  list-style-type: none;\r\n  position: relative;\r\n  padding: 20px 5px 0 5px;\r\n}\r\n\r\n.genealogy-tree li::before,\r\n.genealogy-tree li::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 0;\r\n  right: 50%;\r\n  border-top: 3px solid #d5b14c;\r\n  width: 50%;\r\n  height: 18px;\r\n}\r\n\r\n.genealogy-tree li::after {\r\n  right: auto;\r\n  left: 50%;\r\n  border-left: 3px solid #d5b14c;\r\n}\r\n\r\n.genealogy-tree li:only-child::after,\r\n.genealogy-tree li:only-child::before {\r\n  display: none;\r\n}\r\n\r\n.genealogy-tree li:only-child {\r\n  padding-top: 0;\r\n}\r\n\r\n.genealogy-tree li:first-child::before,\r\n.genealogy-tree li:last-child::after {\r\n  border: 0 none;\r\n}\r\n\r\n.genealogy-tree li:last-child::before {\r\n  border-right: 3px solid #d5b14c;\r\n  border-radius: 0 5px 0 0;\r\n  -webkit-border-radius: 0 5px 0 0;\r\n  -moz-border-radius: 0 5px 0 0;\r\n}\r\n\r\n.genealogy-tree li:first-child::after {\r\n  border-radius: 5px 0 0 0;\r\n  -webkit-border-radius: 5px 0 0 0;\r\n  -moz-border-radius: 5px 0 0 0;\r\n}\r\n\r\n.genealogy-tree ul ul::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 0;\r\n  left: 50%;\r\n  border-left: 3px solid #d5b14c;\r\n  width: 0;\r\n  height: 20px;\r\n}\r\n\r\n.genealogy-tree li a {\r\n  text-decoration: none;\r\n  color: #666;\r\n  font-family: arial, verdana, tahoma;\r\n  font-size: 11px;\r\n  display: inline-block;\r\n  border-radius: 5px;\r\n  -webkit-border-radius: 5px;\r\n  -moz-border-radius: 5px;\r\n}\r\n\r\n/* .genealogy-tree li a:hover+ul li::before,\r\n.genealogy-tree li a:hover+ul::before,\r\n.genealogy-tree li a:hover+ul ul::before,\r\n .genealogy-tree li a:hover+ul li::after */\r\n\r\n/* .genealogy-tree li a+ul li::before\r\n{\r\n    border-color:  green;\r\n} */\r\n\r\n/*--------------memeber-card-design----------*/\r\n\r\n.member-view-box {\r\n  /* padding:0px 20px; */\r\n  text-align: center;\r\n  border-radius: 2px;\r\n  position: relative;\r\n}\r\n\r\n.member-image {\r\n  /* width: 100px; */\r\n  position: relative;\r\n  z-index: 10;\r\n  width: 150px;\r\n}\r\n\r\n.member-image1 {\r\n  z-index: 12;\r\n}\r\n\r\n.member-image:hover {\r\n  transform: scale(1.05);\r\n  transition: 0.3s;\r\n}\r\n\r\n.member-image img {\r\n  height: 73px;\r\n  border-radius: 6px;\r\n  background-color: #000;\r\n  z-index: 1;\r\n  border: 2px solid black;\r\n  width: 100%;\r\n  border-radius: 4px 4px 0px 0px;\r\n  object-fit: fill;\r\n}\r\n\r\n.lock-position {\r\n  position: absolute;\r\n  top: 38%;\r\n  left: 0;\r\n  right: 0;\r\n  width: 100%;\r\n  color: white;\r\n  font-size: 20px;\r\n  color: white;\r\n}\r\n\r\n.child-lock-pos {\r\n  position: absolute;\r\n  top: 37%;\r\n  color: white;\r\n  right: 0;\r\n  margin: 0 auto;\r\n  left: 0;\r\n  font-size: 18px;\r\n}\r\n\r\n/*.unViewed {\r\n  opacity: 0.5; \r\n}*/\r\n\r\n.img-fluid {\r\n  max-width: none !important;\r\n}\r\n\r\n.grabbable {\r\n  cursor: move;\r\n  cursor: grab;\r\n  cursor: -moz-grab;\r\n  cursor: -webkit-grab;\r\n}\r\n\r\n.grabbable:active {\r\n  cursor: grabbing;\r\n  cursor: -moz-grabbing;\r\n  cursor: -webkit-grabbing;\r\n}\r\n\r\n.child-name {\r\n  background: #e6e6e6;\r\n  color: black;\r\n  font-size: 12px;\r\n  margin: 0 auto;\r\n  border-radius: 0px 0px 4px 4px;\r\n  border: 1px solid #9a9a9a;\r\n  padding: 0 2px;\r\n  white-space: initial;\r\n  word-break: break-word;\r\n  line-height: 1.5;\r\n}\r\n\r\n.tree-conntainer {\r\n  padding-left: 0 !important;\r\n  padding-right: 0 !important;\r\n}\r\n\r\n.selected-video {\r\n  background: #4cec5a;\r\n  color: white;\r\n}\r\n\r\n.zoom-btn {\r\n  box-shadow: 1px 1px 4px 0px rgb(0 0 0 / 20%);\r\n  /*WC 03312022*/\r\n  /*color: #000;*/\r\n  font-size: 14px;\r\n  margin: 5px;\r\n  border: none;\r\n  padding: 5px 13px;\r\n  /*background: #fff;*/\r\n  background: #6c2fbb; \r\n  color: #fff; \r\n  border-radius: 5px;\r\n}\r\n\r\n.zoom-btn1 {\r\n  box-shadow: none;\r\n  padding: 8px 32px;\r\n  font-size: 14px;\r\n  background: #6c2fbb;\r\n  color: white;\r\n  border-radius: 5px;\r\n  border: none;\r\n  margin-left: 0px;\r\n  margin-top: 10px;\r\n}\r\n\r\n/*WC 05132022 */\r\n.zoom-btn1::after {\r\n  position: absolute;\r\n  left: 235px;\r\n  background: #5721bf !important;\r\n  border-radius: 5px;\r\n  padding: 17px;\r\n  top: -5px;\r\n  width: 244px;\r\n  border: 2px solid #da6c31;\r\n  color: white;\r\n  font-size: 15px;\r\n  z-index: 2;\r\n}\r\n/*WC 05132022 */\r\n\r\n.fa-check {\r\n  position: absolute;\r\n  bottom: 0;\r\n  left: 0;\r\n  top: 15px;\r\n  right: 0px;\r\n  color: green;\r\n  font-size: 25px;\r\n  z-index: 150;\r\n  pointer-events: none;\r\n}\r\n\r\n@media only screen and (max-width: 992px) {\r\n  .video-js .vjs-tech {\r\n    height: 100% !important;\r\n  }\r\n}\r\n\r\n.video-js .vjs-tech {\r\n  height: 100%;\r\n}\r\n\r\n/* @media (max-width: 768px)  {\r\n    .public-vid-comments .video-js {\r\n        height: 67vh;\r\n    }\r\n} */\r\n\r\n@media (min-width: 492px) and (max-width: 576px) {\r\n  .public-vid-comments .video-js {\r\n    height: 47vh;\r\n  }\r\n}\r\n\r\n@media (min-width: 576px) and (max-width: 768px) {\r\n  .public-vid-comments .video-js {\r\n    height: 69vh;\r\n  }\r\n}\r\n\r\n@media only screen and (min-width: 652px) and (max-width: 992px) {\r\n  .vjs-control.vjs-button[customchoices=\"yes\"] {\r\n    padding: 29px 5px !important;\r\n  }\r\n}\r\n\r\n.tooltips {\r\n  position: relative;\r\n  display: inline-block;\r\n}\r\n\r\n.tooltips .tooltiptext {\r\n  visibility: hidden;\r\n  text-align: center;\r\n  border-radius: 6px;\r\n  padding: 5px 0;\r\n  left: 137px;\r\n  position: absolute;\r\n  top: -168px;\r\n  height: 257px;\r\n  z-index: 1200;\r\n  color: white;\r\n}\r\n\r\n.card-body p {\r\n  font-size: 30px;\r\n  padding: 5px 0px;\r\n  /*padding: 13px 4px;*/\r\n  /* border-bottom: 1px solid; */\r\n}\r\n\r\n.icon-views-upper {\r\n  font-size: 30px;\r\n}\r\n\r\n.icon-align {\r\n  align-items: center;\r\n  color: rgb(0, 0, 0) !important;\r\n  border-bottom: 1px solid #8080802e;\r\n}\r\n\r\n/* .tooltips .tooltiptext::after {\r\n    content: '';\r\n    position: absolute;\r\n    top: 34%;\r\n    left: -70px;\r\n    margin-left: -15px;\r\n    border-width: 50px;\r\n    border-style: solid;\r\n    border-color: transparent rgb(2, 2, 2) transparent transparent;\r\n} */\r\n\r\n.tooltiptextView {\r\n  position: relative;\r\n  visibility: visible !important;\r\n}\r\n\r\n/*.tooltiptext {\r\n}*/\r\n\r\n.tooltip-list ul li {\r\n  list-style: none;\r\n}\r\n\r\n.tooltip-list .card {\r\n  border-radius: 10px;\r\n  /*height: 411px;*/\r\n  width: 268px;\r\n  background-color: rgb(255, 255, 255);\r\n  color: rgb(0, 0, 0);\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.tooltip-list .card-body {\r\n  padding: 0rem !important;\r\n}\r\n\r\n.tooltip-list .card a {\r\n  font-size: 32px;\r\n  border-radius: none;\r\n  border-radius: 0;\r\n  width: 100%;\r\n  margin: 1px 5px;\r\n  color: rgb(0, 0, 0);\r\n}\r\n\r\n.tooltip-list .card a:hover,\r\ni:hover {\r\n  color: rgb(243, 243, 243);\r\n  font-weight: bold;\r\n  transition: 0.5s;\r\n}\r\n\r\n.tooltip-list .card a i {\r\n  color: #f2f2f2 !important;\r\n}\r\n\r\n.tooltip-list .card a i:hover {\r\n  color: #000000 !important;\r\n}\r\n\r\n.fa-question-circle {\r\n  font-size: 36px;\r\n  color: #999999;\r\n}\r\n\r\n.collection-view-text {\r\n  color: #3e3d3d;\r\n}\r\n\r\n.fa-info-circle {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 2px;\r\n  /* color: #ff0000; */\r\n  font-size: 25px;\r\n}\r\n\r\n.form-control {\r\n  box-shadow: none;\r\n  outline: none;\r\n}\r\n\r\n.copied {\r\n  border: 1px solid green;\r\n}\r\n\r\ntable {\r\n  margin-bottom: 18px;\r\n  border-collapse: collapse;\r\n  border-spacing: 0;\r\n  width: 100%;\r\n  border: 1px solid #ddd;\r\n}\r\n\r\nth,\r\ntd,\r\nth {\r\n  text-align: left;\r\n  padding: 16px;\r\n  font-size: 14px;\r\n}\r\n\r\ntr:nth-child(even) {\r\n  background-color: #f2f2f2;\r\n}\r\n\r\n#table_header {\r\n  background: purple;\r\n  color: white;\r\n  font-size: 14px;\r\n  height: 53px !important;\r\n  box-shadow: 0px 0px 5px 0px rgb(0 0 0 / 20%);\r\n}\r\n\r\n.coll-btn {\r\n  padding: 4px 32px;\r\n  font-size: 14px;\r\n  background: #6c2fbb;\r\n  color: white;\r\n  border-radius: 5px;\r\n  float: right;\r\n  outline: none;\r\n  border: none;\r\n  margin-bottom: 29px;\r\n}\r\n\r\n.para-txt {\r\n  font-size: 15px;\r\n  color: #1f1212a8;\r\n}\r\n\r\n.table-view {\r\n  height: 276px;\r\n  overflow: scroll;\r\n  margin-bottom: 24px;\r\n  border: 1px solid #80808029;\r\n  cursor: pointer;\r\n}\r\n\r\n.current-topic {\r\n  font-size: 19px;\r\n  font-weight: 600;\r\n}\r\n\r\n.question-view {\r\n  font-size: 22px;\r\n  position: absolute !important;\r\n  left: 0px;\r\n  top: -2px;\r\n  color: #ba65cc;\r\n  background: #ffffff;\r\n  padding: 6px;\r\n  /* border-radius: 50%; */\r\n  width: 32px;\r\n  height: 32px;\r\n}\r\n\r\n.comment-count {\r\n  position: absolute;\r\n  top: 0px;\r\n  font-size: 18px;\r\n  color: #d2ba45;\r\n  width: 28px;\r\n  height: 28px;\r\n  right: 0px;\r\n  border: 1px solid #d2ba45;\r\n  background-color: white;\r\n}\r\n\r\n.fa-infos {\r\n  font-size: 22px;\r\n  position: absolute;\r\n  left: 0px;\r\n  top: 0px;\r\n  background: white;\r\n  padding: 14px;\r\n  height: 28px;\r\n  width: 28px;\r\n}\r\n\r\n.fa-infos img {\r\n  background: none !important;\r\n  height: 28px !important;\r\n  border: none !important;\r\n  background: white !important;\r\n  padding: 2px !important;\r\n  width: 28px !important;\r\n  position: absolute !important;\r\n  left: 0;\r\n  top: 0;\r\n}\r\n\r\n.share-view {\r\n  padding-left: 0 !important;\r\n  margin: 0;\r\n}\r\n\r\n.test-class {\r\n  display: none;\r\n  position: absolute;\r\n  right: -195px;\r\n  background: none;\r\n  top: -10px;\r\n  color: white;\r\n  padding: 8px;\r\n  box-sizing: border-box;\r\n  z-index: 9999;\r\n  background-color: white;\r\n}\r\n\r\n.view-login {\r\n  display: block !important;\r\n}\r\n\r\n.test-class button {\r\n  border: none;\r\n  background: #8700ff;\r\n  color: white;\r\n  padding: 2px 29px;\r\n  border-radius: 6px;\r\n  font-size: 22px;\r\n}\r\n\r\n.test-class p {\r\n  color: rgb(8 8 8);\r\n  font-weight: bold;\r\n  margin-bottom: 2px;\r\n  font-size: 23px;\r\n}\r\n\r\n/*.tooltip-content {\r\n  padding-left: 1.5rem !important; \r\n}*/\r\n\r\n.pl-2 {\r\n  padding-left: 1.5rem !important;\r\n}\r\n\r\n.is-selceted {\r\n  background-color: purple !important;\r\n  opacity: 0.8;\r\n  color: white;\r\n}\r\n\r\n.fa-exclamation {\r\n  position: relative;\r\n  right: 1px;\r\n}\r\n\r\n.fa-info-circle {\r\n  position: relative;\r\n  top: 0;\r\n  left: -8px;\r\n  font-size: 32px;\r\n}\r\n\r\n.fa-question {\r\n  position: relative;\r\n  right: 3px;\r\n}\r\n\r\n.fa-comment-alt {\r\n  position: relative;\r\n  right: 3px;\r\n}\r\n\r\n.fa-share {\r\n  position: relative;\r\n  right: 3px;\r\n}\r\n\r\n.fa-hands {\r\n  position: relative;\r\n  right: 5px;\r\n}\r\n\r\n.help-box {\r\n  position: absolute;\r\n  left: 175px;\r\n  background: #5721bf !important;\r\n  border-radius: 5px;\r\n  padding: 17px;\r\n  top: 55px;\r\n  width: 244px;\r\n  border: 2px solid #da6c31;\r\n  color: white;\r\n  font-size: 15px;\r\n  z-index: 2;\r\n}\r\n\r\n.wc-help-box {\r\n  position: absolute;\r\n  left: 190px;\r\n  background: #5721bf !important;\r\n  border-radius: 5px;\r\n  padding: 17px;\r\n  top: 0px;\r\n  width: 350px;\r\n  border: 2px solid #da6c31;\r\n  color: white;\r\n  font-size: 15px;\r\n  z-index: 2;\r\n}\r\n\r\n.help-box::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 5%;\r\n  right: 100%;\r\n  margin-top: 0;\r\n  border-width: 15px;\r\n  border-style: solid;\r\n  border-color: transparent #da6c31 transparent transparent;\r\n  height: 24px;\r\n}\r\n\r\n.wc-help-box::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 4%;\r\n  left: 100%;\r\n  margin-top: 0;\r\n  border-width: 15px;\r\n  border-style: solid;\r\n  border-color: transparent #da6c31 transparent transparent;\r\n  height: 24px;\r\n  transform: rotate(180deg);\r\n}\r\n\r\n.fa-times-circle {\r\n  position: absolute;\r\n  right: 10px;\r\n  cursor: pointer;\r\n}\r\n\r\n.OK {\r\n  text-align: right;\r\n  margin-bottom: 0;\r\n  padding: 0;\r\n  cursor: pointer;\r\n}\r\n\r\n.private-badge {\r\n  color: #6c2fbb;\r\n  padding: 5px 15px;\r\n  border: 1px solid #6c2fbb;\r\n  background: #fff;\r\n  border-radius: 12px;\r\n}\r\n\r\n/* WC 05132022 */\r\n\r\n@media (max-width: 767px) {\r\n  .help-box {\r\n    position: absolute;\r\n    left: 200px;\r\n    background: #5721bf !important;\r\n    border-radius: 5px;\r\n    padding: 17px;\r\n    top: 50px;\r\n    width: 150px;\r\n    border: 2px solid #da6c31;\r\n    color: white;\r\n    font-size: 15px;\r\n    z-index: 2;\r\n  }\r\n\r\n  .help-box::after {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 0%;\r\n    left: -25%;\r\n    margin-top: 0;\r\n    border-width: 15px;\r\n    border-style: solid;\r\n    border-color: transparent #da6c31 transparent transparent;\r\n    height: 24px;\r\n    /*transform: rotate(90deg);*/\r\n  }\r\n\r\n  .wc-help-box {\r\n    position: absolute;\r\n    left: 0px;\r\n    background: #5721bf !important;\r\n    border-radius: 5px;\r\n    padding: 15px;\r\n    top: 40px;\r\n    width: 300px;\r\n    border: 2px solid #da6c31;\r\n    color: white;\r\n    font-size: 15px;\r\n    z-index: 2;\r\n  }\r\n\r\n  .wc-help-box::after {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: -18%;\r\n    left: 45%;\r\n    margin-top: 0;\r\n    border-width: 15px;\r\n    border-style: solid;\r\n    border-color: transparent #da6c31 transparent transparent;\r\n    height: 24px;\r\n    transform: rotate(90deg);\r\n  }\r\n}\r\n\r\n@media (max-width: 576px) { \r\n  .help-box {\r\n    position: absolute;\r\n    left: 180px;\r\n    background: #5721bf !important;\r\n    border-radius: 5px;\r\n    padding: 17px;\r\n    top: 40px;\r\n    width: 150px;\r\n    border: 2px solid #da6c31;\r\n    color: white;\r\n    font-size: 15px;\r\n    z-index: 2;\r\n  }\r\n\r\n  .help-box::after {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 0%;\r\n    left: -25%;\r\n    margin-top: 0;\r\n    border-width: 15px;\r\n    border-style: solid;\r\n    border-color: transparent #da6c31 transparent transparent;\r\n    height: 24px;\r\n    /*transform: rotate(90deg);*/\r\n  }\r\n\r\n  .wc-help-box {\r\n    position: absolute;\r\n    left: 0px;\r\n    background: #5721bf !important;\r\n    border-radius: 5px;\r\n    padding: 15px;\r\n    top: 40px;\r\n    width: 300px;\r\n    border: 2px solid #da6c31;\r\n    color: white;\r\n    font-size: 15px;\r\n    z-index: 2;\r\n  }\r\n\r\n  .wc-help-box::after {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: -18%;\r\n    left: 45%;\r\n    margin-top: 0;\r\n    border-width: 15px;\r\n    border-style: solid;\r\n    border-color: transparent #da6c31 transparent transparent;\r\n    height: 24px;\r\n    transform: rotate(90deg);\r\n  }\r\n\r\n  .btn-mania {\r\n    color: #6c2fbb;\r\n    border: 1px solid #6c2fbb;\r\n    padding: 4px 12px;\r\n    font-size: 12px;\r\n    font-weight: 500;\r\n    background: #FFFFFF;\r\n    border-radius: 11px;\r\n    /*margin: 5px 7px;*/\r\n    white-space: nowrap;\r\n  }\r\n\r\n}\r\n\r\n.miniPlayer .custom-height {\r\n  height: 100% !important;\r\n}\r\n\r\n.close-mini-player {\r\n  display: none;\r\n  box-shadow: none !important;\r\n  position: absolute;\r\n  z-index: 9999;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  color: white;\r\n  top: 20px;\r\n  right: 25px;\r\n  font-size: 16px;\r\n}\r\n\r\n.miniPlayer:hover .close-mini-player {\r\n  display: block;\r\n}\r\n\r\n.miniPlayer {\r\n  z-index: 999;\r\n  position: fixed;\r\n  bottom: 20px;\r\n  right: 20px;\r\n  width: 425px;\r\n  height: 225px;\r\n  padding: 15px;\r\n  box-shadow: 0px 11px 15px -7px rgb(0 0 0 / 20%), 0px 24px 38px 3px rgb(0 0 0 / 14%), 0px 9px 46px 8px rgb(0 0 0 / 12%);\r\n  background: #fff;\r\n  color: rgba(0, 0, 0, .87);\r\n  border-radius: 4px;\r\n  overflow: auto;\r\n}\r\n\r\n@media (max-width: 475px) {\r\n  .close-mini-player {\r\n    top: 11px;\r\n    right: 11px;\r\n    font-size: 14px;\r\n  }\r\n\r\n  .miniPlayer {\r\n    width: 50%;\r\n    height: 125px;\r\n    right: 1px;\r\n    padding: 10px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
